<template>
  <div class="jp-tooltip" :class="classes">
    <slot />
    <button
      aria-label="Close"
      class="closebtn"
      @click="$emit('jp-tooltip-close')"
      v-if="closeBtn"
    >
      <FontIcon name="ui_close" />
    </button>
    <div :class="triangleClasses" />
  </div>
</template>

<style lang="scss">
.jp-tooltip {
  position: relative;
  margin: rem(20px);
  padding: rem(16px);
  max-width: rem(335px);
  @include setColor(--color-background1, background-color);
  border-radius: rem(16px);
  box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.1551);

  .closebtn {
    position: absolute;
    top: rem(10px);
    right: rem(10px);
    cursor: pointer;
    outline: none !important;
    @include setColor(--color-cta);
    font-size: rem(16px);
    border: 0;
    pointer-events: all;
    background-color: transparent;

    :hover {
      opacity: 0.7;
    }
  }

  .triangle {
    position: absolute;
    bottom: -12px;
    right: 18px;
    @include triangle(25px 15px, #fff, "down", 53px);
  }
}
</style>

<script>
import FontIcon from "../FontIcon/FontIcon";

export default {
  components: {
    FontIcon,
  },
  props: {
    closeBtn: {
      type: Boolean,
      default: true,
    },
    classes: {
      type: Array,
      default() {
        return [];
      },
    },
    triangleClasses: {
      type: Array,
      default() {
        return ["triangle"];
      },
    },
  },
};
</script>
